import React, { useState } from "react";
import { Dialog, DialogContent, DialogTitle } from "@material-ui/core";
import { CopyToClipboard } from "react-copy-to-clipboard";
import closeIcon from "../../assets/images/blackcross.svg";
import linkimg from "../../assets/images/linkimg.svg";
import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
  XIcon,
} from "react-share";
import { BsXLg } from "react-icons/bs";
import twitterImage from "../../assets/images/footer/x-twitter.svg";

export const ShareModal = ({
  visible,
  shareUrl,
  inputUrl,
  close,
  handleChange,
}) => {
  const [copied, setCopied] = useState(false);

  const handleActivity = (value) => {
    handleChange(value);
    setCopied(false);
  };

  const closeModal = () => {
    setCopied(false);
    close();
  };

  return (
    <Dialog
      id="dialogboxShare"
      className="dialog-style "
      open={visible}
      onClose={closeModal}
    >
      <DialogTitle>
        <div className="row">
          <div className="col-11 col-lg-11">
            <label className="fs-24 semibold ">Share This Video</label>
            <h6>
              {" "}
              <i className="fa-solid fa-xmark-large text-danger "></i>
            </h6>
          </div>
          <div className="col-1 text-right cross-svg  ml-auto">
            <BsXLg
              onClick={closeModal}
              className="crossview cp cross-icons"
            ></BsXLg>
          </div>
        </div>
        <hr className="mb-0 mt-1 "></hr>
      </DialogTitle>
      <DialogContent>
        <div className="row text-center">
          <div style={{ width: "100%" }} class="input-group mb-4 ">
            <input
              style={{ width: "86%", marginLeft: "5px" }}
              value={inputUrl}
              className="linktextbox"
              placeholder={inputUrl}
              onChange={({ target: { value } }) => handleActivity(value)}
            />
            <CopyToClipboard text={inputUrl} onCopy={() => setCopied(true)}>
              <button className="btnlinkCopy">
                <img src={linkimg} alt="copy" className="cp" />
              </button>
            </CopyToClipboard>

            <h6 className="copied-text w-100">{copied ? "Copied" : ""}</h6>
          </div>
        </div>
        <div className="sharing-content px-3 pb-2">
          <FacebookShareButton
            url={shareUrl}
            quote={"Contend Zone Share Media"}
            hashtag={"#Share..."}
          >
            <FacebookIcon size={40} round={true} />
          </FacebookShareButton>
          <WhatsappShareButton
            url={shareUrl}
            quote={"Title or jo bhi aapko likhna ho"}
            hashtag={"#portfolio..."}
          >
            <WhatsappIcon size={40} round={true} />
          </WhatsappShareButton>
          <LinkedinShareButton
            url={shareUrl}
            quote={"Contend Zone Share Media"}
            hashtag={"#Share..."}
          >
            <LinkedinIcon size={40} round={true} />
          </LinkedinShareButton>
          <a
            href="https://twitter.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img
              src={twitterImage}
              style={{
                backgroundColor: "black",
                borderRadius: "50px",
                width: "35px",
              }}
              alt="twitter"
            />
          </a>
        </div>
      </DialogContent>
    </Dialog>
  );
};
